import { useClients } from '@src/clients/hooks/useClients';
import { ManageClients } from '@src/clients/ManageClients';

export const CompaniesPage = () => {
  const { clientList } = useClients();
  const agencies = clientList.agencies();

  return <ManageClients clientList={clientList} addClientAgencies={agencies} />;
};
